import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { setPluginCollaboratorSummary } from 'Workspace/Plugins/store/actions';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { pluginId } = action;

  const workspacePluginCollaboratorSummary = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_PLUGIN_COLLABORATOR_SUMMARY,
    pluginId,
  });

  if (workspacePluginCollaboratorSummary.type === constants.RTM_WORKSPACE_PLUGIN_COLLABORATOR_SUMMARY_OK) {
    const collaborators = workspacePluginCollaboratorSummary.response.collaborators;
    yield put(setPluginCollaboratorSummary(pluginId, collaborators));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage {...messages.failedWorkspacePluginAccountListFetch} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_PLUGIN_COLLABORATOR_SUMMARY, catchErrors, sendRequest, connection);
}
